import React from 'react';
import { render } from 'react-dom';
import { AnalyticsProvider } from '@narvar/nth-hook-context-analytics';
import 'unfetch/polyfill';

import { CustomComponentStateContextProvider } from './hooks/useCustomComponentState';
import App from './components/App';

render(
  <AnalyticsProvider>
    <CustomComponentStateContextProvider>
      <App />
    </CustomComponentStateContextProvider>
  </AnalyticsProvider>,
  document.querySelector('#app'),
);
